import React from 'react';
import { Modal, Button, Form, FormGroup, FormControl } from 'react-bootstrap';
import ValidatedField from '../../Validation/ValidatedField';
import Validator from '../../Validation/Validator';
import Api from '../../../api/api';

const initialState = {
  user: {
    old_password: '',
    password: '',
    password_confirmation: '',
  },
  errors: [],
  message: '',
};

export default class ChangePasswordModal extends React.Component {
  state = initialState;

  validator = new Validator({
    old_password: [Validator.required],
    password: [Validator.required, Validator.min(8)],
    password_confirmation: [Validator.required, Validator.same('password')],
  });

  handleInputChange = (field, e) =>
    this.setState({
      user: {
        ...this.state.user,
        [field]: e.target.value,
      },
    });

  setMessage = message => this.setState({ message });

  handleSubmit = () =>
    this.setState({ errors: [], message: '' }, () => {
      const errors = this.validator.validate(this.state.user);

      if (errors.length) {
        this.setState({ errors });
      } else {
        Api.users
          .updateUserData({ user: this.state.user })
          .then(() => {
            this.setState(initialState);
            this.props.hideModal();
            this.props.setMessage('Your password has been successfully changed.');
          })
          .catch(() => this.setMessage('Invalid password'));
      }
    });

  handleModalClose = () => {
    this.setState(initialState);

    this.props.hideModal();
  };

  render() {
    return (
      <Modal show={this.props.show} className="modal-pass password-change">
        <span className="litpog-remove" onClick={this.handleModalClose} />
        <Modal.Header className="old-pass">
          <Modal.Title>Change password</Modal.Title>
          {/*<Glyphicon glyph="remove" onClick={this.props.hideModal} />*/}
        </Modal.Header>

        <Modal.Body>
          <Form>
            <FormGroup>
              <ValidatedField field="old_password" errors={this.state.errors}>
                <FormControl
                  type="password"
                  placeholder="Old password"
                  onChange={e => this.handleInputChange('old_password', e)}
                  value={this.state.user.old_password}
                />
              </ValidatedField>
              {this.state.message && <span className="errorMessage">{this.state.message}</span>}
            </FormGroup>
            <FormGroup>
              <ValidatedField field="password" errors={this.state.errors}>
                <FormControl
                  type="password"
                  placeholder="New password"
                  onChange={e => this.handleInputChange('password', e)}
                  value={this.state.user.password}
                />
              </ValidatedField>
            </FormGroup>
            <FormGroup>
              <ValidatedField field="password_confirmation" errors={this.state.errors}>
                <FormControl
                  type="password"
                  placeholder="Confirm your password"
                  onChange={e => this.handleInputChange('password_confirmation', e)}
                  value={this.state.user.password_confirmation}
                />
              </ValidatedField>
            </FormGroup>
          </Form>
        </Modal.Body>

        <Modal.Footer className="footer-ok-buttons">
          <Button onClick={this.handleSubmit} bsStyle="primary" className="buttons-ok">
            <span className="buttons-ok-text">submit</span>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Profile/ChangePasswordModal.js